angular.module('filters').filter('utc', function() {
  return function(date, toFormat, fromFormat) {
    var parsedDate;
    if (!date) {
      return;
    }
    toFormat || (toFormat = 'lll');
    parsedDate = fromFormat ? moment.utc(date, fromFormat) : moment.utc(date);
    return parsedDate.format(toFormat);
  };
});
